

























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IWorkTimetable } from "@/@types/excursions/excursions";

import VueTimepicker from "vue2-timepicker";

interface ITimepicker {
  HH: string;
  mm: string;
}

@Component({ components: { VueTimepicker } })
export default class ExcursionWorkTimetabl extends Vue {
  @Prop({ type: Array, default: () => [] }) work_timetable!: IWorkTimetable[];
  days_of_week: Array<string> = [];
  show_timepicker = true;

  start_time: ITimepicker | null = null;
  end_time: ITimepicker | null = null;

  work_time: { start_time: string | Date; end_time: string | Date }[] = [];

  getVariant(j: number): string {
    for (let i = 0; i < this.days_of_week.length; i++) {
      if (this.days_of_week[i] == String(j)) return "outline-primary";
    }
    return "secondary";
  }

  updateDays(i: number): void {
    if (i < 0) {
      this.days_of_week = [];
      for (let j = 0; j < 7; j++) {
        this.days_of_week.push(String(j + 1));
      }
      return;
    }

    for (let j = 0; j < this.days_of_week.length; j++) {
      if (this.days_of_week[j] == String(i)) {
        this.days_of_week.splice(j, 1);
        return;
      }
    }
    this.days_of_week.push(String(i));
  }

  onWorkTimetablSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    for (const day_of_week of this.days_of_week) {
      this.$emit("addWorkTime", {
        day_of_week,
        work_time: this.work_time,
      });
    }
  }

  addWarkingTime(): void {
    if (!this.start_time || !this.end_time) return;
    const start_time = this.start_time.HH + ":" + this.start_time.mm;
    const end_time = this.end_time.HH + ":" + this.end_time.mm;
    this.work_time.push({ start_time, end_time });
    this.start_time = null;
    this.end_time = null;
    this.show_timepicker = false;
    this.$nextTick(() => (this.show_timepicker = true));
  }
}
